import React from "react";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { BsArrowDown } from "react-icons/bs";
import { useSelector } from "react-redux";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useConsultaSped from "../hooks/useConsultaSped";
import { formatarData } from "../../../../components/Formatters/DateTime";
import constants from "../../../Constants";

const sped = { enviar: () => {} };

const processar = (ano, mes) => {
  sped.enviar(ano, mes);
};

const acoes = (ano, mes) => (
  <Button
    variant="light"
    className="text-success"
    style={{ backgroundColor: "white", border: 0 }}
    onClick={() => processar(ano, mes)}
  >
    {mes > 0 ? <b className="fa fa-check" /> : <b className="fa" />}
  </Button>
);

const columns = [
  {
    name: "Ano/Mês",
    center: true,
    cell: (row) => row.ano,
  },
  {
    name: "Janeiro",
    center: true,
    cell: (row) => acoes(row.ano, row.janeiro),
  },
  {
    name: "Fevereiro",
    center: true,
    cell: (row) => acoes(row.ano, row.fevereiro),
  },
  {
    name: "Março",
    center: true,
    cell: (row) => acoes(row.ano, row.marco),
  },
  {
    name: "Abril",
    center: true,
    cell: (row) => acoes(row.ano, row.abril),
  },
  {
    name: "Maio",
    center: true,
    cell: (row) => acoes(row.ano, row.maio),
  },
  {
    name: "Junho",
    center: true,
    cell: (row) => acoes(row.ano, row.junho),
  },
  {
    name: "Julho",
    center: true,
    cell: (row) => acoes(row.ano, row.julho),
  },
  {
    name: "Agosto",
    center: true,
    cell: (row) => acoes(row.ano, row.agosto),
  },
  {
    name: "Setembro",
    center: true,
    cell: (row) => acoes(row.ano, row.setembro),
  },
  {
    name: "Outubro",
    center: true,
    cell: (row) => acoes(row.ano, row.outubro),
  },
  {
    name: "Novembro",
    center: true,
    cell: (row) => acoes(row.ano, row.novembro),
  },
  {
    name: "Dezembro",
    center: true,
    cell: (row) => acoes(row.ano, row.dezembro),
  },
];

const columnsAnalitico = [
  {
    name: "Ano",
    center: true,
    cell: (row) => row.ano,
  },
  {
    name: "Mês",
    center: true,
    cell: (row) => row.mes,
  },
  {
    name: "Finalidade",
    center: true,
    cell: (row) => row.finalidade,
  },
  {
    name: "Entrega",
    center: true,
    cell: (row) => formatarData(row.entrega, "dd/MM/yyyy HH:mm"),
  },
  {
    name: "Processamento",
    center: true,
    cell: (row) => formatarData(row.incorp, "dd/MM/yyyy HH:mm"),
  },
  {
    name: "Status",
    center: true,
    cell: (row) => row.descricaoStatus,
  },
];

const ConsultaSped = ({ dadosOs }) => {
  const {
    isLoading,
    totalRows,
    pageSize,
    handlePageChange,
    handlePerRowsChange,
    handleAnaliticoChange,
    handleImprimirSintetico,
    handleImprimirAnalitico,
  } = useConsultaSped({ dadosOs });

  const { rowsAnalitico, rowsSintetico, dataSintetico } = useSelector((rootReducer) => rootReducer.sped);

  sped.enviar = (ano, mes) => {
    handleAnaliticoChange(ano, mes);
  };

  const imprimirSintetico = () => {
    const dadosSintetico = {
      razaoSocial: dadosOs.razaoSocial,
      cnpj: dadosOs.cnpjCpf,
      ie: dadosOs.inscricaoEstadual,
      nuOs: dadosOs.sequencial,
      enviosSpedEfdSinteticos: dataSintetico,
    };
    handleImprimirSintetico(dadosSintetico);
  };

  const imprimirAnalitico = () => {
    const dadosAnalitico = {
      razaoSocial: dadosOs.razaoSocial,
      cnpj: dadosOs.cnpjCpf,
      ie: dadosOs.inscricaoEstadual,
      nuOs: dadosOs.sequencial,
      enviosSpedEfdAnaliticos: rowsAnalitico,
    };
    handleImprimirAnalitico(dadosAnalitico);
  };

  return (
    <>
      <h1 className="h3 mb-4 text-gray-800">Relatório de Envio de Arquivos - EFD</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-body white">
              <DataTable
                noHeader
                keyField="ano"
                columns={columns}
                data={rowsSintetico}
                progressPending={isLoading}
                noDataComponent="Não existem registros."
                progressComponent={<TextSpinner />}
                defaultSortFieldId={1}
                sortIcon={<BsArrowDown />}
                pagination
                paginationServer
                sortable
                paginationTotalRows={totalRows}
                selectableRows={false}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationComponentOptions={constants.paginationComponentOptions}
                pointerOnHover
                paginationPerPage={pageSize}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 text-left">
          <Button
            variant="primary"
            className="font-weight-bold text-center tamanho-fonte-botao"
            onClick={() => imprimirSintetico()}
          >
            Gerar pdf
          </Button>
          <div className="row">
            <br />
          </div>
        </div>
      </div>
      {rowsAnalitico && rowsAnalitico.length > 0 && (
        <div className="row">
          <div className="col-lg-12">
            <div className="card shadow mb-1">
              <div className="card-body white">
                <DataTable
                  noHeader
                  keyField="ano"
                  columns={columnsAnalitico}
                  data={rowsAnalitico}
                  noDataComponent="Não existem registros."
                  progressComponent={<TextSpinner />}
                  defaultSortFieldId={1}
                  sortIcon={<BsArrowDown />}
                  sortable
                  selectableRows={false}
                  pointerOnHover
                />
              </div>
            </div>
          </div>
          <div className="col-sm-12 text-left">
            <Button
              variant="primary"
              className="font-weight-bold text-center tamanho-fonte-botao"
              onClick={() => imprimirAnalitico()}
            >
              Gerar pdf
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultaSped;
